// Like Button
NP.Like = (function( $ ) {
	var getParam = NP.ns( 'Util.getParam' ),
		getGUID = NP.ns( 'Util.getGUID' ),
		lastNum,
		targetData,
		targetType,
		scroll;

// TODO tmpl 에 옮겨야지
		var template = '<section id="modallessLikeList" class="ly_modalless">\
<div class="wrap_together"><header><h5><strong>좋아요 한 사람들 (#{=it.selector.totalCnt}#명)</strong></h5><a class="js_close close">닫기</a></header>\
<div class="ul_list"><ul></ul></div></div></section>';
		var templateInner = '<li><a href="#{=NP.prflUri( it.crePlayncAcctId )}#">\
<img src="#{=NP.sfile( it.crePlayncAcctId )}#" class="thumb_profile" alt="#{=it.crePlayncAcctNm}#"></a> \
<a class="nickname" href="#{=NP.prflUri( it.crePlayncAcctId )}#">#{=it.crePlayncAcctNm}#</a></li>';
		var templateInnerAcctChar = '<li><a href="#{=NP.prflUri( it.crePlayncAcctId )}#">\
<img src="#{=NP.sfile( it.crePlayncAcctId )}#" class="thumb_profile" alt="#{=it.crePlayncAcctNm}#"></a> \
<a class="nickname" href="#{=NP.prflUri( it.crePlayncAcctId )}#">#{=it.crePlayncAcctNm}#</a> \
#{if( it.wrtChrtId ){}#\
<a class="game" href="#{=NP.bnsPrflUri( it.wrtChrtNm, it.wrtSvrId )}#">[#{=it.wrtChrtNm}#]</a>\
#{}}#</li>';
		var templateInnerChar = '<li><a href="#{=NP.aionPrflUri( it.wrtChrtId, it.wrtSvrId )}#">\
<img src="#{=NP.getCharThumb(it.wrtChrtId, it.wrtSvrId)}#" class="thumb_profile" alt="#{=it.wrtChrtNm}#" \
onerror="this.src=\'http://static.plaync.co.kr/resource/aion/race/race_no_signature.gif\'"></a> \
<a class="game" href="#{=NP.aionPrflUri( it.wrtChrtId, it.wrtSvrId )}#">[#{=it.wrtChrtNm}#]</a></li>';
		
	function getList( postTorg, posttxtServclfseq, postTxtTorgGameId, clickNode ) {
		var articlePosttorg = postTorg || '',
			articlePosttxtservclfseq = posttxtServclfseq || '' ;
			articlePostTxtTorgGameId = postTxtTorgGameId || '' ;
		
		if ( !( NP.dt.v || getGUID() ) ) {
			modal.show({
				txt : '로그인이 필요합니다.',
				button : [['confirm']]
			});

			return;
		}
		
		$.ajax({
			type : 'get',
			url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + ( NP.dt.v || getGUID() ) + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/like.jsonp',
			dataType : 'json',
			data : {
				likeTrgtId : targetData,
				likeType : targetType,
				lastNum : lastNum || 0,
				trgtId : getParam( 'trgtId' )
			},
			success : function( data ) {
				var list = data.likeList;
				lastNum = data.selector.lastNum;

				if ( !list && !list.length ) {
					lastNum = 0;
					scroll.onEnd.empty();
					scroll = null;

					return;
				}
				
				if ( !$('#modallessLikeList' ).length ) {
					var layer = $( ( NP.Util.getTemplate( template ) )( data ) ),
						i = 0,
						item,
						html = '';

					for ( ; item = list[ i ]; i += 1 ) {
						if( NP.isNeedCharacter( { postTorg: articlePosttorg, postTxtServClfSeq: articlePosttxtservclfseq, postTxtTorgGameId: articlePostTxtTorgGameId } ) ){
							//캐릭터 좋아요 리스트
							
							if( !item.wrtChrtId ){
								item.wrtSvrId = '';
								item.wrtGameId = '';
								item.wrtChrtId = '';
								item.wrtChrtNm = '정보를 가져올 수 없습니다.';
							}

							html += ( NP.Util.getTemplate( templateInnerChar ) )( item );
						}else if( ( articlePosttorg === 'CHARACTER_GUESTBOOK' && ( articlePosttxtservclfseq == '145' || articlePostTxtTorgGameId == '102' ) ) ){
							if( !item.wrtChrtId ){
								item.wrtSvrId = '';
								item.wrtGameId = '';
								item.wrtChrtId = '';
							}
							html += ( NP.Util.getTemplate( templateInnerAcctChar ) )( item );
						}else{
							html += ( NP.Util.getTemplate( templateInner ) )( item );
						}
					}

					layer.find( '.ul_list ul' ).html( html );
					
					if( clickNode ){
						var t = clickNode.offset().top,
							l = clickNode.offset().left;
						layer.css({top:( t + 25 ) + 'px', left: ( l - 230 ) + 'px'});
						modalless.show( layer, true );
					}else{
						modalless.show( layer );
					}

				} else {
					var i = 0,
						item,
						html = '';

					for ( ; item = list[ i ]; i += 1 ) {
						html += ( NP.Util.getTemplate( templateInner ) )( item );
					}

					$('#modallessLikeList .ul_list ul' ).append( html );
				}

				if ( !scroll ) {
					scroll = new NP.Scroll( '#modallessLikeList .ul_list ul' );
					scroll.onEnd.add( getList );
				}
			}
		});
	}

	// Like Article
	NP.timeline.on( 'click', '.wrap_feed2 .wrapBtnLike .btnLike', function( e ) {
		if ( !mustLoginIfHasNoSession() ) {
			return;
		}

		if ( NP.Reply.setIsLoading() ) {
			return;
		}
		
		var button = $( this ).parent(),
			text = button.find( '.btnCount .count' ),
			likeValue = button.find( '.btnLike .value' ),
			isLike = button.hasClass( 'unLike' ),
			article = button.parents( 'article:last' ),
			articleData = $.data( article[ 0 ] ),
			reply = article.find( '.wrap_comment' ),
			likeBox = reply.find( '.wrap_feedinfo' ),
			like = likeBox.find( '.like' ),
			articlePosttorg = article.attr( 'data-posttorg' ),
			articlePosttxtservclfseq = article.attr( 'data-posttxtservclfseq' ),
			articlePostTxtTorgGameId = article.attr( 'data-postTxtTorgGameId' ),
			count;
		
//		if ( !( e.target === text[ 0 ] ) ) { // Prevent Abuse
//			return;
//		}
		
		if ( !NP.dt.v ) {
			modal.show({
				txt : '로그인이 필요합니다.',
				button : [[	'confirm']]
			});

			return;
		}
		
		var wrtGameNm = '',
			wrtSvrId ='',
			wrtCharId = '',
			wrtCharNm = '';

		if( NP.isNeedCharacter( { postTorg: articlePosttorg, postTxtServClfSeq: articlePosttxtservclfseq, postTxtTorgGameId: articlePostTxtTorgGameId } ) ){
			wrtCharId = NP.dt.vCharId;
			wrtGameNm = 'aion';
			wrtSvrId = NP.dt.vServerId;
			wrtCharNm = NP.dt.vCharNm || NP.dt.vCharaNm;
			
			if( !wrtCharId ){
				alert( '대표캐릭터를 선택해주세요');
				return;
			}
			
		};
		
		if( ( articlePosttorg === 'CHARACTER_GUESTBOOK' && ( articlePosttxtservclfseq == '145' || articlePostTxtTorgGameId == '102' ) ) ){
			wrtCharId = NP.dt.vCharId;
			wrtGameNm = 'bns';
			wrtSvrId = NP.dt.vServerId;
			wrtCharNm = NP.dt.vCharNm || NP.dt.vCharaNm;
			
			if( !wrtCharId ){
				alert( '대표캐릭터를 선택해주세요');
				return;
			}
		};

		$.ajax({
			type : 'post',
			url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/like.jsonp',
			dataType : 'json',
			data : {
				likeTrgtId : articleData.orgPostTxtSeq || articleData.postTxtSeq,
				likeType : articleData.orgActType || articleData.actType,
				trgtId : getParam( 'trgtId' ),
				wrtSvrId: wrtSvrId || '',
				wrtCharId: wrtCharId || '',
				wrtGameNm: wrtGameNm || '',
				wrtCharNm: wrtCharNm || '',
				'_method' : !isLike ? 'PUT' : 'DELETE'
			},
			beforeSend : function() {
				NP.Reply.setIsLoading( true );
			},
			success : function( data ) {
				button.trigger( 'mouseleave' );
				

				if ( !isLike ) { // 좋아요
					button.addClass( 'unLike' );
					button.addClass( 'on' );
					
					count = NP.Like.setCount( article, '+' );

//					if ( !reply.length ) {
//						article.append( NP.Reply.setUI({
//							post : {
//								likeCnt : 0,
//								rplyTxtCnt : 0
//							},
//							postLikeCount : 1,
//							replyList : []
//						}, true) );
//
//						NP.Placeholder.set( article.find( '.wrap_comment' ) );
//					} else {
//						
//					}
					
					text.text( count );
					likeValue.text( '취소' );
					
				} else { // 좋아요 취소
					button.removeClass( 'unLike' );
					
					count = NP.Like.setCount( article, '-' );
					
					likeValue.text( '좋아요' );

					if ( count ) {
						text.text( count );
					} else {
						button.removeClass( 'on' );
						text.text( 0 );
					}
				}
			},
			complete : function() {
				NP.Reply.setIsLoading( false );
				
				selectbox( '.wrap_form' );
				NP.Character.getCache() && NP.Character.set();
				
			},
			statusCode : {
				400 : function( data ) {
					data = $.parseJSON( data.responseText );

					modal.show({
						txt : data.message,
						button : [[ 'confirm' ]]
					});
				}
			}
		});
	});	

	// Like Reply
	NP.timeline.on( 'click', '.list_comment .cFeed .like', function( e ) {
		if ( !mustLoginIfHasNoSession() ) {
			return;
		}
		
		if ( !NP.dt.v ) {
			modal.show({
				txt : '로그인이 필요합니다.',
				button : [[	'confirm' ]]
			});

			return;
		}
		
		var el = $( this ),
			isLike = el.hasClass( 'on' ),
			reply = el.parents( 'li' ),
			article = el.parents( 'article:last' ),
			articlePosttorg = article.attr( 'data-posttorg' ),
			articlePosttxtservclfseq = article.attr( 'data-posttxtservclfseq' ),
			articlePostTxtTorgGameId = article.attr( 'data-postTxtTorgGameId' ),
			vary;
		
		var wrtGameNm = '',
			wrtSvrId ='',
			wrtCharId = '',
			wrtCharNm = '';
		
		if( NP.isNeedCharacter( { postTorg: articlePosttorg, postTxtServClfSeq: articlePosttxtservclfseq, postTxtTorgGameId: articlePostTxtTorgGameId } ) ){
			wrtCharId = NP.dt.vCharId;
			wrtGameNm = 'aion';
			wrtSvrId = NP.dt.vServerId;
			wrtCharNm = NP.dt.vCharNm || NP.dt.vCharaNm;
			
			if( !wrtCharId ){
				alert( '대표캐릭터를 선택해주세요' );
				return;
			}
		};
		
		if( ( articlePosttorg === 'CHARACTER_GUESTBOOK' && ( articlePosttxtservclfseq == '145' || articlePostTxtTorgGameId == '102' ) ) ){
			wrtCharId = NP.dt.vCharId;
			wrtGameNm = 'bns';
			wrtSvrId = NP.dt.vServerId;
			wrtCharNm = NP.dt.vCharNm || NP.dt.vCharaNm;
			
			if( !wrtCharId ){
				alert( '대표캐릭터를 선택해주세요');
				return;
			}
		};

		$.ajax({
			type : 'post',
			url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/like.jsonp',
			dataType : 'json',
			data : {
				likeTrgtId : $.data( reply[ 0 ] ).rplyTxtSeq,
				likeType : 'REPLY',
				trgtId : getParam( 'trgtId' ),
				wrtSvrId: wrtSvrId || '',
				wrtCharId: wrtCharId || '',
				wrtGameNm: wrtGameNm || '',
				wrtCharNm: wrtCharNm || '',
				'_method' : !isLike ? 'PUT' : 'DELETE'
			},
			success : function( data ) {
				if ( !isLike ) { // 댓글 좋아요
					el.addClass( 'on' ).text( '좋아요 취소' );
					vary = '+';
				} else { // 댓글 좋아요 취소
					el.removeClass( 'on' ).text( '좋아요' );
					vary = '-';
				}
				
				NP.Reply.setLikeCount( reply, vary );
				
				selectbox( '.wrap_form' );
				NP.Character.getCache() && NP.Character.set();
			},
			statusCode : {
				400 : function( data ) {
					data = $.parseJSON( data.responseText );

					modal.show({
						txt : data.message,
						button : [[ 'confirm' ]]
					});
				}
			}
		});
	});

	// Like List
	NP.timeline.on( 'click', '.wrap_feedinfo .like, .list_comment .cFeed .count, .wrap_feed2 .btnCount', function( evt ) {

		var el = $( this );
		
		var article = el.parents( 'article:last' ),
			articlePosttorg = article.attr( 'data-posttorg'),
			articlePosttxtservclfseq = article.attr( 'data-posttxtservclfseq'),
			articlePostTxtTorgGameId = article.attr( 'data-postTxtTorgGameId');
			
		if ( !parseInt( el.text() ) ) {
			return;
		}
		
		if ( $( '#modallessLikeList' ).length ) {
			modalless.hide();
		}

		if ( el.hasClass( 'like' ) || el.hasClass( 'btnCount' ) ) { // 글 좋아요
			var articleData = $.data( el.parents( 'article:last' )[ 0 ] );

			targetData = articleData.orgPostTxtSeq || articleData.postTxtSeq;
			targetType = articleData.orgActType || articleData.actType;
		} else { // 댓글 좋아요
			targetData = $.data( el.parents( 'li' )[ 0 ] ).rplyTxtSeq;
			targetType = 'REPLY';
		}
		scroll = null;
		getList( articlePosttorg, articlePosttxtservclfseq, articlePostTxtTorgGameId, $( this ) );
	});

	return {
		/*setCount : function( article, vary ) {
			var count = article.find( '.like strong span' ),
				value = vary || parseInt( count.text() );

			if ( vary === '+' ) {
				value = parseInt( count.text() ) + 1;
			} else if ( vary === '-' ) {
				value = parseInt( count.text() ) - 1;
			} else {
				value = vary;
			}

			count.text( value );

			return parseInt( count.text() );
		},*/
		setCount : function( article, vary ) {
			var count = article.find( '.btnCount .count' ),
				value = vary || parseInt( count.text() );

			if ( vary === '+' ) {
				value = parseInt( count.text() ) + 1;
			} else if ( vary === '-' ) {
				value = parseInt( count.text() ) - 1;
			} else {
				value = vary;
			}

			count.text( value );

			return parseInt( count.text() );
		},		
		resetLastNum : function() {
			lastNum = 0;
		},
		getLastNum : function() {
			return lastNum;
		}
	}
}( jQuery ));
